import {
  Box,
  Collapse,
  FormControlLabel,
  Grid,
  InputLabel,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { Edicao } from "shared/features/api/edicao/edicaoSlice";
import { IUpdateEditionForm } from "shared/interfaces";

interface UpdateEditionFormProps {
  edicao: Edicao;
}

export const UpdateEditionForm: React.FC<UpdateEditionFormProps> = ({
  edicao,
}) => {
  
  const {
    control,
    register,
    formState: { errors },
    watch
  } = useFormContext<IUpdateEditionForm>();

  const gerenciamentoAtivo = watch("aberturaAgendada") === "T";

  return (
    <Box sx={{ borderRadius: "5px", padding: 2, gap: 2, width: "100%" }}>
      <Typography fontSize={20} fontWeight={600} mb={2}>
        Atualizar Edição
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <InputLabel htmlFor="addEdition-nome">Nome da Edição*</InputLabel>
          <TextField
            fullWidth
            id="addEdition-nome"
            defaultValue={edicao.nome}
            placeholder="Vem Ser 16"
            error={!!errors.nome}
            helperText={errors.nome?.message}
            {...register("nome")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel htmlFor="addEdition-nota">Nota de Corte</InputLabel>
          <TextField
            fullWidth
            id="addEdition-nota"
            defaultValue={edicao.notaCorte}
            placeholder="0.0"
            type="number"
            error={!!errors.notaCorte}
            helperText={errors.notaCorte?.message}
            {...register("notaCorte")}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="aberturaAgendada"
            control={control}
            defaultValue={edicao.aberturaAgendada}
            render={({ field }) => (
              <FormControlLabel
                label="Agendar Inscrições"
                control={
                  <Switch
                    checked={field.value === "T"}
                    onChange={(event) => {
                      field.onChange(event.target.checked ? "T" : "F");
                      console.log(field.value);
                    }}
                  />
                }
              />
            )}
          />
        </Grid>

        <Collapse in={gerenciamentoAtivo} style={{ width: "100%" }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ paddingTop: "16px", paddingLeft: "16px" }}
            >
              <InputLabel htmlFor="dataAberturaInscricao">
                Início das inscrições
              </InputLabel>
              <Controller
                name="dataAberturaInscricao"
                control={control}
                render={({ field }) => {
                  const value = field.value ? new Date(field.value) : null;

                  return (
                    <DateTimePicker
                      value={value}
                      onChange={(newValue: Date | null) => {
                        try {
                          field.onChange(newValue?.toISOString());
                        } catch {
                          field.onChange(newValue);
                        }
                      }}
                      inputFormat="dd/MM/yyyy HH:mm"
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          error={!!errors.dataAberturaInscricao}
                          helperText={errors.dataAberturaInscricao?.message}
                        />
                      )}
                    />
                  );
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              style={{ paddingTop: "16px", paddingLeft: "16px" }}
            >
              <InputLabel htmlFor="dataFimInscricao">
                Final das inscrições
              </InputLabel>
              <Controller
                name="dataFimInscricao"
                control={control}
                render={({ field }) => {
                  const value = field.value ? new Date(field.value) : null;

                  return (
                    <DateTimePicker
                      key={value?.toISOString()}
                      value={value}
                      onChange={(newValue: Date | null) => {
                        try {
                          field.onChange(newValue?.toISOString());
                        } catch {
                          field.onChange(newValue);
                        }
                      }}
                      inputFormat="dd/MM/yyyy HH:mm"
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          error={!!errors.dataFimInscricao}
                          helperText={errors.dataFimInscricao?.message}
                        />
                      )}
                    />
                  );
                }}
              />
            </Grid>
          </Grid>
        </Collapse>

        <Grid item xs={12}>
          <FormControlLabel
            label="Abrir Inscrições"
            control={
              <Controller
                name="inscricoesAberta"
                control={control}
                defaultValue={edicao.inscricoesAberta}
                render={({ field }) => (
                  <Switch
                    checked={field.value === "T"}
                    onChange={(e) => {
                      field.onChange(e.target.checked ? "T" : "F");
                    }}
                  />
                )}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};